import {
    DialogInfoServiceUnavailableComponent
} from './components/dialog-info-service-unavailable/dialog-info-service-unavailable.component';
import { InfoDialog } from './interfaces/info-dialog-data.interface';

export const DIALOG_INFO_COMPONENT_MAP: Record<string, InfoDialog> = {
    'service-unavailable': {
        title: 'Usługa jest niedostępna',
        component: DialogInfoServiceUnavailableComponent
    }
};
